import { Link } from "react-router-dom";
import { formatUnits } from "viem";
import { getTokenByChainIdAndAddress } from "common";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RoundAccordionContribution(_ref) {
  var _contribution$applica;
  let {
    contribution
  } = _ref;
  const {
    chainId,
    roundId,
    applicationId,
    amount
  } = contribution;
  const projectName = (_contribution$applica = contribution.application) === null || _contribution$applica === void 0 ? void 0 : _contribution$applica.project.name;
  const amountInUsd = contribution.amountInUsd.toFixed(2);
  const linkToRound = `/round/${chainId}/${roundId.toString().toLowerCase()}/${applicationId}`;
  let formattedAmount = "N/A";
  const token = getTokenByChainIdAndAddress(contribution.chainId, contribution.tokenAddress);
  if (token) {
    formattedAmount = `${formatUnits(BigInt(amount), token.decimals)} ${token.code}`;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "flex items-center justify-between px-4 font-modern-era-regular font-normal text-base/[26px]",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex flex-col flex-1",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex items-center",
        children: /*#__PURE__*/_jsx(Link, {
          className: `underline inline-block lg:max-w-[300px] max-w-[75px] 2xl:max-w-fit truncate`,
          title: projectName,
          to: linkToRound,
          target: "_blank",
          children: projectName
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-1 text-center truncate",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "text-black",
        children: [formattedAmount, " "]
      }), /*#__PURE__*/_jsxs("span", {
        className: "text-grey-400",
        children: ["/ $", amountInUsd]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-1"
    })]
  });
}